import React, { useCallback } from "react";

import { ToastBar, Toaster, toast } from "react-hot-toast";

const ToasterWrapper = () => {
  const handleToastDismiss = useCallback((t) => {
    toast.dismiss(t.id);
  }, []);

  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 2000
        }}
      >
        {(t) => {
          return (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {t.type !== "loading" && (
                    <button
                      className="toasterBtn"
                      onClick={() => handleToastDismiss(t)}
                    >
                      {icon}
                    </button>
                  )}
                  {message}
                </>
              )}
            </ToastBar>
          );
        }}
      </Toaster>
    </>
  );
};

export default ToasterWrapper;
